import React, { useState, useEffect, useRef } from "react";
import { Button } from 'antd';
import { LeftOutlined, RightOutlined, PauseOutlined, CaretRightOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { currency, onlyTwoDigits, formatterMetrico } from '../helpers/formatter'


function MenuMetricos(props) {

    const sections = props.data ? props.data : []
    const [expandItemSection, setExpandItemSection] = useState(0);
    const [itemSelected, setItemSelected] = useState(null);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [scrollPosition, setScrollPosition] = useState('LEFT');
    const [scrollActive, setScrollActive] = useState(true);
    const [scrollPause, setScrollPause] = useState(false);

    const scrollRef = useRef(null);

    const scroll = (scrollOffset) => {
        scrollRef.current.scrollLeft += scrollOffset;
    };

    useEffect(() => {

        let myInterval = setInterval(() => {

            let maxScrollLeft = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;

            if (scrollPosition === 'LEFT' && scrollActive && !scrollPause) {
                scrollRef.current.scrollLeft += 260
            } else if (scrollActive && !scrollPause) {
                scrollRef.current.scrollLeft -= 260
            } else {
                clearInterval(myInterval);
            }
            setScrollLeft(scrollRef.current.scrollLeft)

            if (scrollLeft === maxScrollLeft) {
                setScrollPosition('RIGHT')

            }

            if (scrollLeft === 0) {
                setScrollPosition('LEFT')
            }

        }, 1500)
        return () => {
            clearInterval(myInterval);
        };
    });


    function onMouseEnter() {
        setScrollActive(false)
    }

    function onMouseLeave() {
        setScrollActive(true)
    }

    function onMouseOver() {
        if (scrollActive) {
            setScrollActive(false)
        }
    }

    function selectMetrico(event, item, indexItem, indexSection) {

        let start = 0
        if (event.target.className.includes("m-menu-section-item") ||
            event.target.className.includes("m-menu-item-title") ||
            event.target.className.includes("m-menu-item-values")) {
            start = event.target.offsetLeft - 44 - scrollRef.current.scrollLeft
        } else {
            start = event.target.offsetLeft - 52 - scrollRef.current.scrollLeft
        }

        scrollRef.current.scrollLeft += start

        setItemSelected(item.codigo)
        props.selectMetrico(item)

    }

    function onChangeExpand(value) {
        setExpandItemSection(value)
    }

    useEffect(() => {

        if (props.data.length > 0) {
            if (props.data[0].metricos.length > 0) {
                if (itemSelected == null) {
                    setItemSelected(props.data[0].metricos[0].codigo)
                }

            }

        }

    }, [props.data]);


    const listSection = sections.map((section, indexSection) => {
        return <div className="m-menu-container-section" key={indexSection}>
            <div className="m-menu-section">
                {section.nombre}
            </div>
            {
                section.metricos.map((item, indexItem) => {
                    return (item.estatus === 1 ? <div key={indexItem} className={itemSelected == item.codigo ? "m-menu-section-item m-color-selected-border-bottom" : "m-menu-section-item"} onClick={(event) => selectMetrico(event, item, indexItem, indexSection)}>
                        <div className="m-menu-item-title" >
                            {item.nombre}
                            <div className="m-menu-item-key">
                                {item.codigo}
                            </div>
                        </div>
                        <div className="m-menu-item-values">
                            <div className={`m-menu-item-value m-color-${item.color} ${itemSelected == item.codigo ? "m-color-selected-font-menu" : ""}`}>
                                {item.valores.length > 0 ? formatterMetrico(item.valores[0].valor, item.valores[0].valor_formato) : ""}


                                    {item.data == 0 ? '' : <InfoCircleOutlined  style={{ marginLeft: '10px', fontSize: '15px'}}/>}
                                
                            </div>

                        </div>
                    </div> : null)
                })
            }
        </div>
    })

    return (
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseOver={onMouseOver}>
            <div className="m-menu-container" ref={scrollRef}>
                {listSection}
            </div>
            {sections.length > 0 ?
                <div className="m-menu-scroll-buttons">
                    <div style={{ width: "44px", height: "32px", textAlign: "center" }}>
                        <Button onClick={() => setScrollPause(!scrollPause)} type="link" icon={scrollPause ? <CaretRightOutlined /> : <PauseOutlined />} />
                    </div>
                    <div style={{ width: "44px", height: "32px", textAlign: "center" }}>
                        <Button onClick={() => scroll(-260)} type="link" icon={<RightOutlined />} />
                    </div>
                    <div style={{ width: "44px", height: "36px", textAlign: "center" }}>
                        <Button onClick={() => scroll(260)} type="link" icon={<LeftOutlined />} />
                    </div>
                </div> : null}


        </div>
    );
}

export default MenuMetricos;